export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Timestamp: { input: string; output: string; }
};

export type AddProductToCartInput = {
  cartItemId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddPromocodeUnion = {
  __typename?: 'AddPromocodeUnion';
  /** Корзина */
  cart?: Maybe<CartModel>;
  /** Промокод в корзине, если есть */
  cartPromoCode?: Maybe<CartPromocodesModel>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** вид промокода */
  identify?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AfterOrderPromocodeUnion = {
  __typename?: 'AfterOrderPromocodeUnion';
  /** Код промокода */
  code?: Maybe<Scalars['String']['output']>;
  /** Срок действия промокода */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Картинка цифрового товара */
  image?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Текст цифрового товара */
  text?: Maybe<Scalars['String']['output']>;
  /** Наименование цифрового товара */
  title?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  /** Значение промокода */
  value?: Maybe<Scalars['Float']['output']>;
};

export type AttachmentsCacheModel = {
  __typename?: 'AttachmentsCacheModel';
  file?: Maybe<Scalars['String']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  filePath?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  file_webp?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Float']['output']>;
  filetype?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type AttachmentsModel = {
  __typename?: 'AttachmentsModel';
  bannerItem?: Maybe<Array<BannersModel>>;
  cacheItem?: Maybe<Array<AttachmentsCacheModel>>;
  converted?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  file_old?: Maybe<Scalars['String']['output']>;
  file_webp?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Float']['output']>;
  filetype?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isVideo?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  object_id?: Maybe<Scalars['Float']['output']>;
  preview_id?: Maybe<Scalars['Float']['output']>;
  stretchFilePath: Scalars['String']['output'];
  tempFullFilePath: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  tmp?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type BannersModel = {
  __typename?: 'BannersModel';
  active?: Maybe<Scalars['String']['output']>;
  catalogTypes?: Maybe<Array<CatalogTypesModel>>;
  catalog_type_id?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  default_banner?: Maybe<Scalars['String']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  file_new?: Maybe<Scalars['String']['output']>;
  for_all?: Maybe<Scalars['String']['output']>;
  for_unauth?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  link?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['String']['output']>;
  peopleProfiles?: Maybe<Array<PeopleProfileModel>>;
  position?: Maybe<Scalars['Float']['output']>;
  profile_id?: Maybe<Scalars['Int']['output']>;
  promotionItem?: Maybe<PromotionsModel>;
  promotion_id?: Maybe<Scalars['Int']['output']>;
  status_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Timestamp']['output']>;
};

export type CartFieldsModel = {
  __typename?: 'CartFieldsModel';
  cart_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CartItemsModel = {
  __typename?: 'CartItemsModel';
  amount?: Maybe<Scalars['Float']['output']>;
  cartItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  catalogAnalogs?: Maybe<Array<CatalogModel>>;
  catalogItem?: Maybe<CatalogModel>;
  catalogKitItem?: Maybe<CatalogKitModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  freeOfCharge?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_active_for_order?: Maybe<Scalars['Boolean']['output']>;
  kit_id?: Maybe<Scalars['Int']['output']>;
  multiPriceAmount?: Maybe<Scalars['Float']['output']>;
  nearestDeliveryAmount?: Maybe<Scalars['Int']['output']>;
  orderItem?: Maybe<OrdersItemsModel>;
  order_item_id?: Maybe<Scalars['Int']['output']>;
  postcards?: Maybe<Array<CartPostcardsModel>>;
  product?: Maybe<CatalogModel>;
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  /** спец цена */
  purchase_price?: Maybe<Scalars['Float']['output']>;
  specialAmountPricesItem?: Maybe<CartMultiPricesModel>;
  /** спец цена относительно среднего веса товара */
  specialPrice?: Maybe<Scalars['Float']['output']>;
  specialPricesItem?: Maybe<CartMultiPricesModel>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CartLoyaltyProgramModel = {
  __typename?: 'CartLoyaltyProgramModel';
  cartItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  freeDelivery?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  is_free_delivery?: Maybe<Scalars['Float']['output']>;
  loyaltyProgram?: Maybe<LoyaltyProgramModel>;
  loyaltyProgramItem?: Maybe<LoyaltyProgramModel>;
  loyalty_program_id?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<CatalogModel>;
  productItem?: Maybe<CatalogModel>;
  product_id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<ServicesModel>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
};

export type CartModel = {
  __typename?: 'CartModel';
  addressConfirmedByUser?: Maybe<Scalars['Boolean']['output']>;
  addressItem?: Maybe<PeopleAddressesModel>;
  address_id?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  billPayed?: Maybe<Scalars['Float']['output']>;
  bill_payed?: Maybe<Scalars['Float']['output']>;
  canOrderBeCreated?: Maybe<Scalars['Boolean']['output']>;
  cartItems?: Maybe<Array<CartItemsModel>>;
  cartLoyaltyProgram?: Maybe<Array<CartLoyaltyProgramModel>>;
  cartLoyaltyProgramItems?: Maybe<Array<CartLoyaltyProgramModel>>;
  cartPromocodes?: Maybe<Array<CartPromocodesModel>>;
  cartServicesItems?: Maybe<Array<CartServicesModel>>;
  cartTestDrive?: Maybe<CartTestDrivesModel>;
  cartTestDriveItem?: Maybe<CartTestDrivesModel>;
  cityItem?: Maybe<OrdersCitiesModel>;
  city_id?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** стоимость тары */
  containerPrice?: Maybe<Scalars['Float']['output']>;
  cookieId?: Maybe<Scalars['String']['output']>;
  cookie_id?: Maybe<Scalars['String']['output']>;
  coords?: Maybe<Scalars['String']['output']>;
  dadata?: Maybe<DadataModel>;
  dadataItem?: Maybe<DadataModel>;
  dadata_id?: Maybe<Scalars['Int']['output']>;
  deliveryCost?: Maybe<Scalars['Float']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryIntervalEnd?: Maybe<Scalars['Int']['output']>;
  deliveryIntervalId?: Maybe<Scalars['Int']['output']>;
  deliveryIntervalStart?: Maybe<Scalars['Int']['output']>;
  deliveryIntervals?: Maybe<Array<DataFlexibleDeliveryIntervalsUnion>>;
  deliveryItem?: Maybe<OrdersDeliveryModel>;
  delivery_cost?: Maybe<Scalars['Float']['output']>;
  delivery_date?: Maybe<Scalars['Timestamp']['output']>;
  delivery_id?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<CartFieldsModel>>;
  fio?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  /** Подарки в корзине */
  gifts?: Maybe<Array<CatalogModel>>;
  /** Глобальный подарок всем при любом заказе */
  globalGift?: Maybe<CatalogModel>;
  id?: Maybe<Scalars['Int']['output']>;
  interval_end?: Maybe<Scalars['Int']['output']>;
  interval_end_minutes?: Maybe<Scalars['Int']['output']>;
  interval_id?: Maybe<Scalars['Int']['output']>;
  interval_start?: Maybe<Scalars['Int']['output']>;
  interval_start_minutes?: Maybe<Scalars['Int']['output']>;
  is_menu?: Maybe<Scalars['Int']['output']>;
  /** Товарные позиции */
  items?: Maybe<Array<CartItemsModel>>;
  lastCartStoreId?: Maybe<Scalars['Int']['output']>;
  /** включена ли настройка - меньше пакетов */
  lessContainers?: Maybe<Scalars['Boolean']['output']>;
  menu_people_id?: Maybe<Scalars['Int']['output']>;
  minAllowableTotal?: Maybe<Scalars['Int']['output']>;
  minCartTotalToCreateOrder?: Maybe<Scalars['Int']['output']>;
  needReceipt?: Maybe<Scalars['Boolean']['output']>;
  need_receipt?: Maybe<Scalars['Float']['output']>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  payment?: Maybe<OrdersPaymentsModel>;
  paymentItem?: Maybe<OrdersPaymentsModel>;
  payment_id?: Maybe<Scalars['Int']['output']>;
  people?: Maybe<PeopleModel>;
  peopleAddress?: Maybe<PeopleAddressesModel>;
  peopleItem?: Maybe<PeopleModel>;
  peopleRegionAddresses?: Maybe<Array<PeopleAddressesModel>>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Возможный бонус */
  possibleBonus?: Maybe<PossibleBonusUnion>;
  price?: Maybe<Scalars['Float']['output']>;
  promoCodes?: Maybe<Array<CartPromocodesModel>>;
  promocodeItem?: Maybe<PromocodesModel>;
  promocode_id?: Maybe<Scalars['Int']['output']>;
  services?: Maybe<Array<CartServicesModel>>;
  storeCityItem?: Maybe<StoresCityModel>;
  storeItem?: Maybe<StoresModel>;
  store_city_confirm?: Maybe<Scalars['Int']['output']>;
  store_city_id?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** Тест-драйвы, на участие в которых можно подать заявку */
  testDrives?: Maybe<Array<TestDriveModel>>;
  timeid?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  /** Подсказка по сумме заказа */
  totalAmountHint?: Maybe<TotalAmountUnion>;
  /** Итого с учётом стоимости доставки */
  totalWithDeliveryPrice?: Maybe<Scalars['Float']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
};

export type CartMultiPricesModel = {
  __typename?: 'CartMultiPricesModel';
  /** кол-во товара по спец цене */
  amount?: Maybe<Scalars['Float']['output']>;
  /** спец цена: привязана к полю 'amount' */
  amount_price?: Maybe<Scalars['Float']['output']>;
  cartItem?: Maybe<CartItemsModel>;
  cartItemsItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  cart_item_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Первоначальная цена товара */
  original_price?: Maybe<Scalars['Float']['output']>;
  productItem?: Maybe<CatalogModel>;
  product_id?: Maybe<Scalars['Int']['output']>;
  /** спец цена: привязана к полям 'pay_for', 'buy_at_once' */
  special_price?: Maybe<Scalars['Float']['output']>;
};

export type CartMultipleUnion = {
  __typename?: 'CartMultipleUnion';
  /** Корзина */
  cart?: Maybe<CartModel>;
  /** Результат выполнения запроса */
  cartUnions?: Maybe<Array<CartUnion>>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
  /** Если какие-то продукты не удалось добавить */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type CartNotAvailableItemsUnion = {
  __typename?: 'CartNotAvailableItemsUnion';
  /** Товары/Наборы */
  cartItems?: Maybe<Array<CartItemsModel>>;
  /** Элементы программы лояльности */
  cartLoyaltyProgram?: Maybe<Array<CartLoyaltyProgramModel>>;
  /** Услуги */
  cartPromoCodes?: Maybe<Array<CartPromocodesModel>>;
  /** Услуги */
  cartServices?: Maybe<Array<CartServicesModel>>;
  /** Тестдрайвы */
  cartTestDrives?: Maybe<CartTestDrivesModel>;
};

export type CartPostcardInput = {
  /** ID позиции в корзине */
  cartItemId?: InputMaybe<Scalars['Int']['input']>;
  /** ID открытки */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** От кого */
  sender?: InputMaybe<Scalars['String']['input']>;
  /** Текст для открытки */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CartPostcardsModel = {
  __typename?: 'CartPostcardsModel';
  cartItem?: Maybe<CartItemsModel>;
  cartItemsItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  cart_item_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CartPromocodesModel = {
  __typename?: 'CartPromocodesModel';
  actual?: Maybe<Scalars['Int']['output']>;
  cartItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  is_actual?: Maybe<Scalars['Int']['output']>;
  promoCode?: Maybe<PromocodesModel>;
  promocodeItem?: Maybe<PromocodesModel>;
  promocode_id?: Maybe<Scalars['Int']['output']>;
};

export type CartServiceProductInput = {
  /** ID набора в корзине */
  kitId?: InputMaybe<Scalars['Int']['input']>;
  /** ID товара в корзине */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** Кол-во товара */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CartServicesModel = {
  __typename?: 'CartServicesModel';
  amount?: Maybe<Scalars['Float']['output']>;
  cartItem?: Maybe<CartModel>;
  cartServiceProductItems?: Maybe<Array<CartServicesProductsModel>>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Int']['output'];
  is_for_manager?: Maybe<Scalars['Int']['output']>;
  is_subscription?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<ServicesModel>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
  subscription?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CartServicesProductsModel = {
  __typename?: 'CartServicesProductsModel';
  cartServiceItem?: Maybe<CartServicesModel>;
  cart_service_id?: Maybe<Scalars['Int']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalogKitItem?: Maybe<CatalogKitModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  kit_id?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
};

export type CartShareUnion = {
  __typename?: 'CartShareUnion';
  /** Уникальный код корзины */
  code?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** URL, который можно передать друзьям */
  url?: Maybe<Scalars['String']['output']>;
};

export type CartTestDrivesModel = {
  __typename?: 'CartTestDrivesModel';
  cartItem?: Maybe<CartModel>;
  cart_id?: Maybe<Scalars['Int']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  product?: Maybe<CatalogModel>;
  testDrive?: Maybe<TestDriveModel>;
  testDriveItem?: Maybe<TestDriveModel>;
  test_drive_id?: Maybe<Scalars['Int']['output']>;
};

export type CartUnion = {
  __typename?: 'CartUnion';
  /** Корзина */
  cart?: Maybe<CartModel>;
  /** Товарная позиция, если есть */
  cartItem?: Maybe<CartItemsModel>;
  /** Промокод в корзине, если есть */
  cartPromoCode?: Maybe<CartPromocodesModel>;
  cartService?: Maybe<CartServicesModel>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Позиции в заказе, которые вдруг стали недоступны */
  notAvailableItems?: Maybe<CartNotAvailableItemsUnion>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type CatalogAmountsModel = {
  __typename?: 'CatalogAmountsModel';
  amount: Scalars['Float']['output'];
  catalogItem?: Maybe<CatalogModel>;
  date?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

export type CatalogAnalogUnion = {
  __typename?: 'CatalogAnalogUnion';
  catalogId?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<CatalogModel>>;
};

export type CatalogBadgesRubricsUnion = {
  __typename?: 'CatalogBadgesRubricsUnion';
  discount?: Maybe<CatalogBadgesUnion>;
  hit?: Maybe<CatalogBadgesUnion>;
  natural?: Maybe<CatalogBadgesUnion>;
  newbee?: Maybe<CatalogBadgesUnion>;
  promotion?: Maybe<CatalogBadgesUnion>;
  superprice?: Maybe<CatalogBadgesUnion>;
};

export type CatalogBadgesUnion = {
  __typename?: 'CatalogBadgesUnion';
  available?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CatalogBreadUnion = {
  __typename?: 'CatalogBreadUnion';
  binding?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CatalogCommentsModel = {
  __typename?: 'CatalogCommentsModel';
  _voted?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerUserItem?: Maybe<UsersModel>;
  answer_date?: Maybe<Scalars['Timestamp']['output']>;
  answer_user_id?: Maybe<Scalars['Int']['output']>;
  auto_fixed_date?: Maybe<Scalars['Timestamp']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  fixed_date?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Int']['output'];
  is_auto_fixed?: Maybe<Scalars['Float']['output']>;
  is_fixed?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  order_id?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  test_drive_id?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  votes_no?: Maybe<Scalars['Float']['output']>;
  votes_yes?: Maybe<Scalars['Float']['output']>;
};

export type CatalogDeliveryUnion = {
  __typename?: 'CatalogDeliveryUnion';
  available?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  day_month?: Maybe<Scalars['String']['output']>;
  day_month_weekday_full?: Maybe<Scalars['String']['output']>;
  day_month_weekday_short?: Maybe<Scalars['String']['output']>;
  day_of_week?: Maybe<Scalars['String']['output']>;
  dom?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  is_nearest?: Maybe<Scalars['Boolean']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  nextFreeInterval?: Maybe<Scalars['Boolean']['output']>;
  nextFreeIntervalItem?: Maybe<CatalogDeliveryUnion>;
  price?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Timestamp']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleFull?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  will_be_closed?: Maybe<Scalars['Float']['output']>;
  zone?: Maybe<Scalars['Float']['output']>;
};

export type CatalogImgUnion = {
  __typename?: 'CatalogImgUnion';
  big?: Maybe<Array<Scalars['String']['output']>>;
  original?: Maybe<Array<Scalars['String']['output']>>;
  small?: Maybe<Array<Scalars['String']['output']>>;
  square?: Maybe<Array<Scalars['String']['output']>>;
};

export type CatalogKitModel = {
  __typename?: 'CatalogKitModel';
  active?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  catalogList?: Maybe<Array<CatalogModel>>;
  comments_number?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  is_ready_set?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  promotion_id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  sales_number?: Maybe<Scalars['Float']['output']>;
  special_conditions?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CatalogMeasuresModel = {
  __typename?: 'CatalogMeasuresModel';
  active?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CatalogModel = {
  __typename?: 'CatalogModel';
  _rubricWeight?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  availableQuantity?: Maybe<Array<CatalogAmountsModel>>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  badges?: Maybe<CatalogBadgesRubricsUnion>;
  bonus_payment_enabled?: Maybe<Scalars['Float']['output']>;
  bonus_points?: Maybe<Scalars['Float']['output']>;
  bread?: Maybe<Array<CatalogBreadUnion>>;
  canAddReviewComment?: Maybe<Scalars['Boolean']['output']>;
  /** покупал ли пользователь товар и может ему ставить оценку -> Реализовано в сущночти комментария getProductCommentsById => productPeopleBuy */
  canRate?: Maybe<Scalars['Boolean']['output']>;
  cartItemId?: Maybe<Scalars['Int']['output']>;
  /** принудительно ограничено количество возвращаемых полей в товарах - в случае необходимости расширять через бэк */
  catalogAnalogs?: Maybe<Array<CatalogModel>>;
  check_amount?: Maybe<Scalars['String']['output']>;
  classified_id?: Maybe<Scalars['String']['output']>;
  commentsList?: Maybe<Array<CatalogCommentsModel>>;
  comments_number?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  ctg_id?: Maybe<Scalars['Float']['output']>;
  currentPriceField?: Maybe<Scalars['Float']['output']>;
  currentPriceField2?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  delivery?: Maybe<CatalogDeliveryUnion>;
  delivery_day?: Maybe<Scalars['String']['output']>;
  delivery_days?: Maybe<Scalars['String']['output']>;
  delivery_text?: Maybe<Scalars['String']['output']>;
  delivery_time?: Maybe<Scalars['Float']['output']>;
  delivery_type?: Maybe<Scalars['String']['output']>;
  digital?: Maybe<Scalars['Boolean']['output']>;
  discounPriceField?: Maybe<Scalars['Float']['output']>;
  discounPriceField2?: Maybe<Scalars['Float']['output']>;
  dlv_id?: Maybe<Scalars['Float']['output']>;
  energy_value?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['String']['output']>;
  favoritesList?: Maybe<Array<FavoritesModel>>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  forbid_discount?: Maybe<Scalars['Boolean']['output']>;
  gds_box?: Maybe<Scalars['Float']['output']>;
  gds_cntbeg?: Maybe<Scalars['Float']['output']>;
  gds_cntlen?: Maybe<Scalars['Float']['output']>;
  gds_code?: Maybe<Scalars['String']['output']>;
  gds_codebeg?: Maybe<Scalars['Float']['output']>;
  gds_codelen?: Maybe<Scalars['Float']['output']>;
  gds_control?: Maybe<Scalars['String']['output']>;
  gds_count?: Maybe<Scalars['Float']['output']>;
  gds_del?: Maybe<Scalars['String']['output']>;
  gds_descr?: Maybe<Scalars['String']['output']>;
  gds_enabled_old?: Maybe<Scalars['Float']['output']>;
  gds_expire?: Maybe<Scalars['Float']['output']>;
  gds_mincnt?: Maybe<Scalars['Float']['output']>;
  gds_mintype?: Maybe<Scalars['String']['output']>;
  gds_name?: Maybe<Scalars['String']['output']>;
  gds_nds?: Maybe<Scalars['Float']['output']>;
  gds_pack?: Maybe<Scalars['Float']['output']>;
  gds_packing?: Maybe<Scalars['Float']['output']>;
  gds_part?: Maybe<Scalars['Float']['output']>;
  gds_place?: Maybe<Scalars['String']['output']>;
  gds_price?: Maybe<Scalars['Float']['output']>;
  gds_prod1?: Maybe<Scalars['Timestamp']['output']>;
  gds_prod2?: Maybe<Scalars['Timestamp']['output']>;
  gds_psv?: Maybe<Scalars['String']['output']>;
  gds_psvto?: Maybe<Scalars['Timestamp']['output']>;
  gds_reserv?: Maybe<Scalars['Float']['output']>;
  gds_sertif?: Maybe<Scalars['Timestamp']['output']>;
  gds_warn?: Maybe<Scalars['Float']['output']>;
  gds_weight_old?: Maybe<Scalars['Float']['output']>;
  gds_wonds?: Maybe<Scalars['Float']['output']>;
  getURL?: Maybe<Scalars['String']['output']>;
  gost?: Maybe<Scalars['String']['output']>;
  hit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  images?: Maybe<CatalogImgUnion>;
  inet_id_old?: Maybe<Scalars['Float']['output']>;
  inet_name?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Scalars['String']['output']>;
  isAvailableForPurchase?: Maybe<Scalars['Boolean']['output']>;
  isBigCard?: Maybe<Scalars['Boolean']['output']>;
  isDigitalAutoItem?: Maybe<PromocodesModel>;
  isExpressDeliveryAval?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isInFavorites?: Maybe<Scalars['Boolean']['output']>;
  isMenu?: Maybe<Scalars['Boolean']['output']>;
  isNotForSaleBarMenu?: Maybe<Scalars['Boolean']['output']>;
  isPostponed?: Maybe<Scalars['Boolean']['output']>;
  isPromo?: Maybe<Scalars['Boolean']['output']>;
  isPromo1?: Maybe<Scalars['Boolean']['output']>;
  is_digital_auto?: Maybe<Scalars['Int']['output']>;
  is_natural?: Maybe<Scalars['String']['output']>;
  is_not_for_index?: Maybe<Scalars['String']['output']>;
  is_not_for_sale?: Maybe<Scalars['String']['output']>;
  is_pinned?: Maybe<Scalars['Float']['output']>;
  is_postcard_allowed?: Maybe<Scalars['Float']['output']>;
  kitList?: Maybe<Array<CatalogKitModel>>;
  mainBarRubric?: Maybe<CatalogTypesModel>;
  mainImage?: Maybe<Scalars['String']['output']>;
  mainRootRubric?: Maybe<CatalogTypesModel>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  maxPurchase?: Maybe<Scalars['Int']['output']>;
  max_purchase?: Maybe<Scalars['Float']['output']>;
  measureItem?: Maybe<CatalogMeasuresModel>;
  measure_id?: Maybe<Scalars['Int']['output']>;
  modify_date?: Maybe<Scalars['Timestamp']['output']>;
  mostUsefulComment?: Maybe<CatalogCommentsModel>;
  multiPrices?: Maybe<Array<CatalogMultiPricesModel>>;
  nearestDelivery?: Maybe<CatalogDeliveryUnion>;
  newbee?: Maybe<Scalars['String']['output']>;
  nutritional_value?: Maybe<Scalars['String']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  oldPriceField?: Maybe<Scalars['Float']['output']>;
  oldPriceField2?: Maybe<Scalars['Float']['output']>;
  old_id?: Maybe<Scalars['Float']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  plc_id?: Maybe<Scalars['Float']['output']>;
  popular_main?: Maybe<Scalars['String']['output']>;
  postcardAllowed?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** нужно ли выводить верхний доп. блок с ценами */
  priceBlockWeightPrice?: Maybe<Scalars['Boolean']['output']>;
  price_active?: Maybe<Scalars['Float']['output']>;
  price_current?: Maybe<Scalars['Float']['output']>;
  price_kit?: Maybe<Scalars['Float']['output']>;
  price_promo?: Maybe<Scalars['Float']['output']>;
  price_retail?: Maybe<Scalars['Float']['output']>;
  price_sale?: Maybe<Scalars['Float']['output']>;
  price_wholesale?: Maybe<Scalars['Float']['output']>;
  /** Сообщить о скидке */
  productDiscountNotification?: Maybe<Scalars['Boolean']['output']>;
  productPhotoWrap?: Maybe<Scalars['String']['output']>;
  promotionsItems?: Maybe<Array<PromotionsItemsModel>>;
  rating?: Maybe<Scalars['Float']['output']>;
  rating_comments?: Maybe<Scalars['Float']['output']>;
  recipes_text?: Maybe<Scalars['String']['output']>;
  recommend?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<Scalars['String']['output']>;
  relFilter?: Maybe<Array<CatalogRelationsModel>>;
  relProfile?: Maybe<Array<CatalogRelationsModel>>;
  relType?: Maybe<Array<CatalogRelationsModel>>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
  rubricsFilters?: Maybe<Array<CatalogTypeFiltersModel>>;
  sales_number?: Maybe<Scalars['Float']['output']>;
  seo_auto?: Maybe<Scalars['Float']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  show_recommendations?: Maybe<Scalars['String']['output']>;
  sovkomSaleSector?: Maybe<Scalars['Float']['output']>;
  specialConditions: Scalars['String']['output'];
  special_conditions?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CatalogStatusesModel>;
  statusItem?: Maybe<CatalogStatusesModel>;
  status_id?: Maybe<Scalars['Int']['output']>;
  storage_conditions?: Maybe<Scalars['String']['output']>;
  storeStatusItems: Array<CatalogStoresStatusesModel>;
  subProducts?: Maybe<Array<CatalogModel>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  superPrice?: Maybe<Scalars['String']['output']>;
  superprice?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['Float']['output']>;
  symbolPriceField?: Maybe<Scalars['String']['output']>;
  symbolPriceField2?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  txt_groups?: Maybe<Scalars['String']['output']>;
  typesList?: Maybe<Array<CatalogTypesModel>>;
  unt_id_old?: Maybe<Scalars['Float']['output']>;
  vesovoi?: Maybe<Scalars['String']['output']>;
  /** список видео, полученных из поля text */
  videoFromText?: Maybe<Array<Scalars['String']['output']>>;
  videoItem?: Maybe<AttachmentsModel>;
  video_code?: Maybe<Scalars['String']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
  video_title?: Maybe<Scalars['String']['output']>;
  video_youtube?: Maybe<Scalars['String']['output']>;
  war_id?: Maybe<Scalars['Float']['output']>;
  weightOfGoods?: Maybe<Scalars['Float']['output']>;
  weightOfPacking?: Maybe<Scalars['Float']['output']>;
  weight_of_goods?: Maybe<Scalars['Float']['output']>;
  weight_of_packing?: Maybe<Scalars['Float']['output']>;
};

export type CatalogMultiPricesModel = {
  __typename?: 'CatalogMultiPricesModel';
  _addAmount?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  buy_at_once?: Maybe<Scalars['Float']['output']>;
  gds_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pay_for?: Maybe<Scalars['Float']['output']>;
  price_active?: Maybe<Scalars['Float']['output']>;
  price_current?: Maybe<Scalars['Float']['output']>;
  price_retail?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  programm?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  staff?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  stop?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

export type CatalogPriceChangesModel = {
  __typename?: 'CatalogPriceChangesModel';
  catalog_id?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  dateTime?: Maybe<Scalars['Float']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  old_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<CatalogModel>;
};

export type CatalogRelationsModel = {
  __typename?: 'CatalogRelationsModel';
  catalogItem: CatalogModel;
  filterItem: CatalogTypeFiltersModel;
  filter_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  profileItem: PeopleProfileModel;
  profile_id?: Maybe<Scalars['Float']['output']>;
  special_event_id?: Maybe<Scalars['Float']['output']>;
  spectypeItem: CatalogTypesModel;
  spectype_id?: Maybe<Scalars['Int']['output']>;
  typeItem: CatalogTypesModel;
  type_id?: Maybe<Scalars['Int']['output']>;
};

export type CatalogStatusesModel = {
  __typename?: 'CatalogStatusesModel';
  id: Scalars['Int']['output'];
  is_search?: Maybe<Scalars['Float']['output']>;
  is_subscribe?: Maybe<Scalars['Float']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CatalogStoresStatusesModel = {
  __typename?: 'CatalogStoresStatusesModel';
  id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  status_id?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

export type CatalogTypeFiltersModel = {
  __typename?: 'CatalogTypeFiltersModel';
  active?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  catalogList?: Maybe<Array<CatalogModel>>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  isAll?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parentItem?: Maybe<CatalogTypesModel>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  relFiltersList?: Maybe<Array<CatalogRelationsModel>>;
  seo_canonical?: Maybe<Scalars['String']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesale_items?: Maybe<Scalars['Float']['output']>;
};

export type CatalogTypesModel = {
  __typename?: 'CatalogTypesModel';
  _productId?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  badge_text?: Maybe<Scalars['String']['output']>;
  bg_color?: Maybe<Scalars['String']['output']>;
  big_cards?: Maybe<Scalars['Float']['output']>;
  children?: Maybe<Array<CatalogTypesModel>>;
  childrenItems?: Maybe<Array<CatalogTypesModel>>;
  children_ids?: Maybe<Scalars['String']['output']>;
  children_title?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Float']['output']>;
  filter_title?: Maybe<Scalars['String']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  genitive?: Maybe<Scalars['String']['output']>;
  hit_count?: Maybe<Scalars['Float']['output']>;
  icon_hover_id?: Maybe<Scalars['Float']['output']>;
  icon_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  inflection?: Maybe<Scalars['String']['output']>;
  isAll?: Maybe<Scalars['Boolean']['output']>;
  is_menu?: Maybe<Scalars['Float']['output']>;
  is_not_for_index?: Maybe<Scalars['String']['output']>;
  is_not_for_sale?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  modified_at?: Maybe<Scalars['Timestamp']['output']>;
  natural_count?: Maybe<Scalars['Float']['output']>;
  newbee?: Maybe<Scalars['Float']['output']>;
  parentItem?: Maybe<CatalogTypesModel>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  parent_special?: Maybe<Scalars['String']['output']>;
  productsList?: Maybe<Array<CatalogModel>>;
  promo?: Maybe<Scalars['Float']['output']>;
  seo_canonical?: Maybe<Scalars['String']['output']>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_template_md?: Maybe<Scalars['String']['output']>;
  seo_template_mkw?: Maybe<Scalars['String']['output']>;
  seo_template_title?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  short_title?: Maybe<Scalars['String']['output']>;
  special?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  typesItems?: Maybe<Array<CatalogTypesModel>>;
  uri?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesale_items?: Maybe<Scalars['Float']['output']>;
};

export type CheckCartUnion = {
  __typename?: 'CheckCartUnion';
  /** Глобальный подарок всем (из настроек сайта) */
  globalGift?: Maybe<CatalogModel>;
  /** Промокоды, которые стали недоступны */
  notAvailablePromoCodes?: Maybe<Array<PromocodesModel>>;
  /** Доступные автоматические промокоды */
  possibleAutoPromoCodes?: Maybe<Array<PromocodesModel>>;
  /** Доступные автоматические услуги */
  possibleAutoServices?: Maybe<Array<ServicesModel>>;
  /** Изменение цены на товары */
  priceChanges?: Maybe<Array<CatalogPriceChangesModel>>;
  /** Товары, у которых изменился статус */
  statusChanges?: Maybe<Array<CatalogModel>>;
};

export type CheckMaxAvailableQuantityInOneOrderUnion = {
  __typename?: 'CheckMaxAvailableQuantityInOneOrderUnion';
  cartItem?: Maybe<CartItemsModel>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  maxAllowedQuantity?: Maybe<Scalars['Int']['output']>;
  maxAllowedQuantityOnDate?: Maybe<Scalars['Int']['output']>;
  multiPriceAmount?: Maybe<Scalars['Int']['output']>;
  multiPriceSum?: Maybe<Scalars['Float']['output']>;
};

export type ConfigType = {
  __typename?: 'ConfigType';
  value: Scalars['String']['output'];
};

export type CoordinatesInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type CourierModel = {
  __typename?: 'CourierModel';
  cur_car?: Maybe<Scalars['String']['output']>;
  cur_cargo?: Maybe<Scalars['Float']['output']>;
  cur_count?: Maybe<Scalars['Float']['output']>;
  cur_del?: Maybe<Scalars['String']['output']>;
  cur_fixpay?: Maybe<Scalars['Float']['output']>;
  cur_fuel?: Maybe<Scalars['Float']['output']>;
  cur_id: Scalars['Int']['output'];
  cur_len?: Maybe<Scalars['Float']['output']>;
  cur_name?: Maybe<Scalars['String']['output']>;
  cur_ordcnt?: Maybe<Scalars['Float']['output']>;
  cur_ordpay?: Maybe<Scalars['Float']['output']>;
  cur_phone?: Maybe<Scalars['String']['output']>;
  cur_psp?: Maybe<Scalars['String']['output']>;
  cur_sms?: Maybe<Scalars['String']['output']>;
  cur_speed?: Maybe<Scalars['Float']['output']>;
  cur_staff?: Maybe<Scalars['String']['output']>;
  cur_used?: Maybe<Scalars['String']['output']>;
  cur_wave?: Maybe<Scalars['Float']['output']>;
  cur_workbeg?: Maybe<Scalars['Timestamp']['output']>;
  cur_zone?: Maybe<Scalars['String']['output']>;
  dadata_id?: Maybe<Scalars['Float']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  medknItem?: Maybe<AttachmentsModel>;
  medkn_id?: Maybe<Scalars['Int']['output']>;
};

/** Создание цифрового заказа */
export type CreateDigitalOrderInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  from: PersonDataInput;
  paymentId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  to: PersonDataInput;
};

export type DadataModel = {
  __typename?: 'DadataModel';
  area?: Maybe<Scalars['String']['output']>;
  areaType?: Maybe<Scalars['String']['output']>;
  area_fias_id?: Maybe<Scalars['String']['output']>;
  area_kladr_id?: Maybe<Scalars['String']['output']>;
  area_type?: Maybe<Scalars['String']['output']>;
  beltway_distance?: Maybe<Scalars['Float']['output']>;
  beltway_hit?: Maybe<Scalars['Float']['output']>;
  block?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  block_type?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityType?: Maybe<Scalars['String']['output']>;
  city_area?: Maybe<Scalars['String']['output']>;
  city_district?: Maybe<Scalars['String']['output']>;
  city_district_fias_id?: Maybe<Scalars['String']['output']>;
  city_district_type?: Maybe<Scalars['String']['output']>;
  city_fias_id?: Maybe<Scalars['String']['output']>;
  city_kladr_id?: Maybe<Scalars['String']['output']>;
  city_type?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Timestamp']['output']>;
  fias_id?: Maybe<Scalars['String']['output']>;
  fias_level?: Maybe<Scalars['Float']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  geoLat?: Maybe<Scalars['Float']['output']>;
  geoLon?: Maybe<Scalars['Float']['output']>;
  geo_lat?: Maybe<Scalars['Float']['output']>;
  geo_lon?: Maybe<Scalars['Float']['output']>;
  house?: Maybe<Scalars['String']['output']>;
  houseType?: Maybe<Scalars['String']['output']>;
  house_fias_id?: Maybe<Scalars['String']['output']>;
  house_kladr_id?: Maybe<Scalars['String']['output']>;
  house_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isValidForExpress?: Maybe<Scalars['Boolean']['output']>;
  is_cleaned?: Maybe<Scalars['Float']['output']>;
  is_fixed?: Maybe<Scalars['Float']['output']>;
  kladr_id?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['Timestamp']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  qc?: Maybe<Scalars['Float']['output']>;
  qc_geo?: Maybe<Scalars['Float']['output']>;
  raw_json?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  region_fias_id?: Maybe<Scalars['String']['output']>;
  region_kladr_id?: Maybe<Scalars['String']['output']>;
  region_type?: Maybe<Scalars['String']['output']>;
  settlement?: Maybe<Scalars['String']['output']>;
  settlementType?: Maybe<Scalars['String']['output']>;
  settlement_fias_id?: Maybe<Scalars['String']['output']>;
  settlement_kladr_id?: Maybe<Scalars['String']['output']>;
  settlement_type?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetType?: Maybe<Scalars['String']['output']>;
  street_fias_id?: Maybe<Scalars['String']['output']>;
  street_kladr_id?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

export type DataFlexibleDeliveryIntervalsUnion = {
  __typename?: 'DataFlexibleDeliveryIntervalsUnion';
  assemblyTime?: Maybe<Scalars['Float']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  canChangeRange?: Maybe<Scalars['Boolean']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  intervals?: Maybe<Array<IntervalsFlexibleDeliveryIntervalsUnion>>;
  isDiscountProduct: Scalars['Boolean']['output'];
  nearestIntervalTitle?: Maybe<Scalars['String']['output']>;
  notAvailableGifts?: Maybe<Array<CatalogModel>>;
  notAvailableProducts?: Maybe<Array<CartItemsModel>>;
  notAvailablePromocodes?: Maybe<Array<CartPromocodesModel>>;
  /** данные по недоступным товарам вместе с максимально доступным количеством */
  notAvaliableCatalogsWithAmount?: Maybe<Array<CheckMaxAvailableQuantityInOneOrderUnion>>;
  notAvaliableLoyaltyProducts?: Maybe<Array<CatalogModel>>;
  notAvaliableServices?: Maybe<Array<CartServicesModel>>;
  recommendedTime?: Maybe<Array<RecommendedTimeItemUnion>>;
  storeId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeliveryIntervalInput = {
  end: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type DeliveryLatestIntervalUnion = {
  __typename?: 'DeliveryLatestIntervalUnion';
  interval?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  willBeClosed?: Maybe<Scalars['Float']['output']>;
};

export type FavoritesModel = {
  __typename?: 'FavoritesModel';
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Int']['output'];
  is_postponed?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  recipeItem?: Maybe<RecipesModel>;
  recipe_id?: Maybe<Scalars['Int']['output']>;
};

export type FavoritesMutationResponseType = {
  __typename?: 'FavoritesMutationResponseType';
  error?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type GetDeliveryIntervalsUnion = {
  __typename?: 'GetDeliveryIntervalsUnion';
  error?: Maybe<Scalars['String']['output']>;
  express?: Maybe<Array<DataFlexibleDeliveryIntervalsUnion>>;
  intervals?: Maybe<Array<DataFlexibleDeliveryIntervalsUnion>>;
};

/** размер картинки */
export enum ImgeFilterE {
  D44 = 'd44',
  D100 = 'd100',
  D120 = 'd120',
  D295 = 'd295',
  D454 = 'd454',
  H37 = 'h37',
  H315 = 'h315',
  W24h24 = 'w24h24',
  W40 = 'w40',
  W69h69 = 'w69h69',
  W80h80 = 'w80h80',
  W140 = 'w140',
  W140h140 = 'w140h140',
  W140m = 'w140m',
  W240h240 = 'w240h240',
  W270h200 = 'w270h200',
  W295 = 'w295',
  W300 = 'w300',
  W335h140 = 'w335h140',
  W480 = 'w480',
  W480h344 = 'w480h344',
  W530 = 'w530',
  W800h600 = 'w800h600',
  W900h700 = 'w900h700'
}

export type IntervalsFlexibleDeliveryIntervalsUnion = {
  __typename?: 'IntervalsFlexibleDeliveryIntervalsUnion';
  date?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Int']['output']>;
  endMinutes?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  interval_end_minutes?: Maybe<Scalars['String']['output']>;
  interval_start_minutes?: Maybe<Scalars['String']['output']>;
  maxStart?: Maybe<Scalars['Int']['output']>;
  minWidth?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  selectedEnd?: Maybe<Scalars['Int']['output']>;
  selectedStart?: Maybe<Scalars['Int']['output']>;
  selectedWidth?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  startMinutes?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyProgramModel = {
  __typename?: 'LoyaltyProgramModel';
  bonusPercentage?: Maybe<Scalars['Int']['output']>;
  bonus_percentage?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  freeDelivery?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  is_active?: Maybe<Scalars['Float']['output']>;
  is_free_delivery?: Maybe<Scalars['Float']['output']>;
  maxQuantityInOrder?: Maybe<Scalars['Int']['output']>;
  max_quantity_in_order?: Maybe<Scalars['Float']['output']>;
  minOrderPrice?: Maybe<Scalars['Int']['output']>;
  modified_at?: Maybe<Scalars['Timestamp']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  people_status_id?: Maybe<Scalars['Int']['output']>;
  previous_order_price?: Maybe<Scalars['Float']['output']>;
  productsAsGifts?: Maybe<Array<CatalogModel>>;
  servicesAsGifts?: Maybe<Array<ServicesModel>>;
  statusItem?: Maybe<PeopleStatusModel>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MetroLinesModel = {
  __typename?: 'MetroLinesModel';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type MetroStationsModel = {
  __typename?: 'MetroStationsModel';
  id: Scalars['Int']['output'];
  line: MetroLinesModel;
  line_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Добавление открытки к товару */
  addCartItemPostcard: CartUnion;
  /** Добавить товары, наборы и услуги из ранее сделанного заказа в корзину. Для повтора крайнего заказа следует передать latest = true и значение orderId = 0. */
  addItemsToCartFromOrder: CartUnion;
  addItemsToCartFromTemplate: CartUnion;
  /** добавить товар в корзину */
  addMultipleProductsToCart: CartMultipleUnion;
  addPeopleAddress: PeopleAddressMutationResponseType;
  /** добавить товар в корзину */
  addProductToCart: CartUnion;
  addProductToPostponedList: FavoritesMutationResponseType;
  addServiceToCart: CartUnion;
  applicationForParticipationInTestDrive: CartUnion;
  applyPromoCode?: Maybe<AddPromocodeUnion>;
  cancelOrder: OrderUnion;
  cancelTestDriveApplication: CartUnion;
  clearCart: CartUnion;
  confirmDigitalOrder: Scalars['Boolean']['output'];
  confirmProfileBySMS: PeopleMutationResponseType;
  createCartFromOrder: CartUnion;
  createDigitalOrder: OrderUnion;
  createMenuOrderFromCart: OrderUnion;
  createOrderFromCart: OrderUnion;
  loginManually?: Maybe<PeopleModel>;
  logout: Scalars['Boolean']['output'];
  mergeCarts: CartUnion;
  payOrderWithBonuses: CartUnion;
  /** @deprecated Use payOrderWithBonuses */
  payWithBonuses: CartUnion;
  removeCartItem: CartUnion;
  /** Удалить открытку у товара в корзине */
  removeCartItemPostcard: CartUnion;
  removeCartPromoCode: CartUnion;
  removeCartService: CartUnion;
  removePeopleAddress: PeopleMutationResponseType;
  removeProductFromPostponedList: FavoritesMutationResponseType;
  /** Сохранить изменения в заказе (токен от текущей корзины) */
  saveChangesToOrder: OrderUnion;
  subscribeToPushNotifications: WebPushModel;
  undoChangesToOrder: CartUnion;
  /** Обновить некоторые поля в корзине */
  updateCart: CartUnion;
  updateCartCity: CartModel;
  updateCartLoyaltyProgram: CartUnion;
  updateOrCreateMenuCart: CartModel;
  updatePeople: PeopleMutationResponseType;
  updatePeopleAddress: PeopleAddressMutationResponseType;
};


export type MutationAddCartItemPostcardArgs = {
  cartToken: Scalars['String']['input'];
  postcards: Array<CartPostcardInput>;
};


export type MutationAddItemsToCartFromOrderArgs = {
  cartToken: Scalars['String']['input'];
  latest: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationAddItemsToCartFromTemplateArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationAddMultipleProductsToCartArgs = {
  cartToken: Scalars['String']['input'];
  continueAnyway?: Scalars['Boolean']['input'];
  productsToAddToCart: Array<AddProductToCartInput>;
};


export type MutationAddPeopleAddressArgs = {
  peopleAddressData: PeopleAddressInput;
};


export type MutationAddProductToCartArgs = {
  cartItemId?: InputMaybe<Scalars['Int']['input']>;
  cartToken: Scalars['String']['input'];
  continueAnyway?: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationAddProductToPostponedListArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddServiceToCartArgs = {
  cartServiceId?: InputMaybe<Scalars['Float']['input']>;
  cartToken: Scalars['String']['input'];
  continueAnyway?: Scalars['Boolean']['input'];
  forManager?: Scalars['Boolean']['input'];
  products?: CartServiceProductInput;
  quantity?: Scalars['Int']['input'];
  serviceId: Scalars['Int']['input'];
};


export type MutationApplicationForParticipationInTestDriveArgs = {
  cartToken: Scalars['String']['input'];
  testDriveId: Scalars['Int']['input'];
};


export type MutationApplyPromoCodeArgs = {
  cartToken: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelOrderArgs = {
  cancelComment?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  reasonId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCancelTestDriveApplicationArgs = {
  cartToken: Scalars['String']['input'];
  testDriveId: Scalars['Int']['input'];
};


export type MutationClearCartArgs = {
  cartToken: Scalars['String']['input'];
};


export type MutationConfirmDigitalOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationConfirmProfileBySmsArgs = {
  action?: InputMaybe<PeopleSmsAction>;
  cartToken?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCartFromOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationCreateDigitalOrderArgs = {
  data: CreateDigitalOrderInput;
};


export type MutationCreateMenuOrderFromCartArgs = {
  cartToken: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateOrderFromCartArgs = {
  cartData: SaveOrderInput;
  cartToken: Scalars['String']['input'];
  isDuplicateRequest?: Scalars['Boolean']['input'];
};


export type MutationLoginManuallyArgs = {
  id: Scalars['Float']['input'];
  key: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationMergeCartsArgs = {
  registration?: Scalars['Boolean']['input'];
  sourceCartItemId?: InputMaybe<Scalars['Int']['input']>;
  sourceCartToken?: InputMaybe<Scalars['String']['input']>;
  targetCartToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPayOrderWithBonusesArgs = {
  amount: Scalars['Float']['input'];
  cartToken: Scalars['String']['input'];
};


export type MutationPayWithBonusesArgs = {
  amount: Scalars['Int']['input'];
  cartToken: Scalars['String']['input'];
};


export type MutationRemoveCartItemArgs = {
  cartItemId: Scalars['Int']['input'];
  cartItemsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  cartToken: Scalars['String']['input'];
  continueAnyway?: Scalars['Boolean']['input'];
};


export type MutationRemoveCartItemPostcardArgs = {
  cartPostcardId: Scalars['Int']['input'];
  cartToken: Scalars['String']['input'];
};


export type MutationRemoveCartPromoCodeArgs = {
  cartPromoCodeId: Scalars['Int']['input'];
  cartToken: Scalars['String']['input'];
};


export type MutationRemoveCartServiceArgs = {
  cartServiceId: Scalars['Int']['input'];
  cartToken: Scalars['String']['input'];
  continueAnyway?: Scalars['Boolean']['input'];
  quantity?: Scalars['Int']['input'];
};


export type MutationRemovePeopleAddressArgs = {
  peopleAddressId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveProductFromPostponedListArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveChangesToOrderArgs = {
  cartData: SaveOrderInput;
  cartToken: Scalars['String']['input'];
  editV2?: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationSubscribeToPushNotificationsArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  mobileApp?: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationUndoChangesToOrderArgs = {
  cartToken: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationUpdateCartArgs = {
  cartData: UpdateCartInput;
  cartToken: Scalars['String']['input'];
};


export type MutationUpdateCartCityArgs = {
  cartToken: Scalars['String']['input'];
  cityId: Scalars['Float']['input'];
  storeId?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateCartLoyaltyProgramArgs = {
  cartLoyaltyProgramId: Scalars['Int']['input'];
  cartToken: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateOrCreateMenuCartArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  menu_people_id?: InputMaybe<Scalars['Int']['input']>;
  store_id: Scalars['Int']['input'];
};


export type MutationUpdatePeopleArgs = {
  data?: PeopleUpdateInput;
  email?: InputMaybe<Scalars['String']['input']>;
  fio?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePeopleAddressArgs = {
  peopleAddressData: PeopleAddressInput;
};

/** Фильтры для поиска уведомлений пользователя */
export type NotificationInput = {
  /** Кол-во элементов (ElementsPerPage) для отображения (не более 100) */
  epp?: Scalars['Int']['input'];
  /** Смещение курсора */
  eppOffset?: Scalars['Int']['input'];
  /** тема уведомления - заказ, промокод, акции */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Тип уведомления (sms, push, etc...) */
  type: Scalars['String']['input'];
};

export type NotificationsListUnion = {
  __typename?: 'NotificationsListUnion';
  currentPageNumber?: Maybe<Scalars['Int']['output']>;
  elementsPerPage?: Maybe<Scalars['Int']['output']>;
  itemsLeft?: Maybe<Scalars['Int']['output']>;
  itemsList?: Maybe<Array<PeopleNotificationModel>>;
  itemsTotal?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderLoyaltyProgramModel = {
  __typename?: 'OrderLoyaltyProgramModel';
  loyaltyProgramItem?: Maybe<LoyaltyProgramModel>;
  loyalty_program_id?: Maybe<Scalars['Float']['output']>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  productItem?: Maybe<CatalogModel>;
  product_id?: Maybe<Scalars['Int']['output']>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
};

export type OrderMultiPricesModel = {
  __typename?: 'OrderMultiPricesModel';
  /** кол-во товара по спец цене */
  amount?: Maybe<Scalars['Float']['output']>;
  /** спец цена: привязана к полю 'amount' */
  amount_price?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderItem?: Maybe<OrdersItemsModel>;
  orderItemsItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  order_item_id?: Maybe<Scalars['Int']['output']>;
  /** Первоначальная цена товара */
  original_price?: Maybe<Scalars['Float']['output']>;
  productItem?: Maybe<CatalogModel>;
  product_id?: Maybe<Scalars['Int']['output']>;
  /** спец цена: привязана к полям 'pay_for', 'buy_at_once' */
  special_price?: Maybe<Scalars['Float']['output']>;
};

export type OrderUnion = {
  __typename?: 'OrderUnion';
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  /** Корзина */
  order?: Maybe<OrdersModel>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Номер стола для барного заказа */
  table?: Maybe<Scalars['Int']['output']>;
  /** Токен авторизации нового клиента (слать в x-people-token) */
  token?: Maybe<Scalars['String']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type OrdersCancelReasonsModel = {
  __typename?: 'OrdersCancelReasonsModel';
  active?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OrdersCitiesModel = {
  __typename?: 'OrdersCitiesModel';
  active?: Maybe<Scalars['String']['output']>;
  cty_del?: Maybe<Scalars['String']['output']>;
  dadata_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  old_id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OrdersDeliveryModel = {
  __typename?: 'OrdersDeliveryModel';
  active?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  min_price?: Maybe<Scalars['Int']['output']>;
  region_id?: Maybe<Scalars['Int']['output']>;
  timeid?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type OrdersItemsModel = {
  __typename?: 'OrdersItemsModel';
  amount?: Maybe<Scalars['Float']['output']>;
  barcodes?: Maybe<Scalars['String']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  containers?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  gds_id_old?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_amount?: Maybe<Scalars['Float']['output']>;
  item_price?: Maybe<Scalars['Float']['output']>;
  item_weight?: Maybe<Scalars['Float']['output']>;
  kit_id?: Maybe<Scalars['Float']['output']>;
  new_id?: Maybe<Scalars['Float']['output']>;
  ord_bonus?: Maybe<Scalars['Float']['output']>;
  ord_dscnt?: Maybe<Scalars['Float']['output']>;
  ord_id_old?: Maybe<Scalars['Float']['output']>;
  ord_prc?: Maybe<Scalars['Float']['output']>;
  ord_price?: Maybe<Scalars['Float']['output']>;
  ord_qnty?: Maybe<Scalars['Float']['output']>;
  ord_weight?: Maybe<Scalars['Float']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  ordersItem?: Maybe<OrdersModel>;
  prc_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  specialPricesItem?: Maybe<OrderMultiPricesModel>;
  trf_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weight_total?: Maybe<Scalars['Float']['output']>;
};

export type OrdersManagersModel = {
  __typename?: 'OrdersManagersModel';
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  ug_id?: Maybe<Scalars['Float']['output']>;
  us_del?: Maybe<Scalars['String']['output']>;
  us_id: Scalars['Int']['output'];
  us_login?: Maybe<Scalars['String']['output']>;
  us_name?: Maybe<Scalars['String']['output']>;
  us_password?: Maybe<Scalars['String']['output']>;
  us_sms?: Maybe<Scalars['String']['output']>;
};

export type OrdersModel = {
  __typename?: 'OrdersModel';
  actionpay?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  addressItem?: Maybe<PeopleAddressesModel>;
  address_id?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_store_id?: Maybe<Scalars['Int']['output']>;
  bill_payed?: Maybe<Scalars['Float']['output']>;
  bill_received?: Maybe<Scalars['Float']['output']>;
  bill_recieved?: Maybe<Scalars['Float']['output']>;
  cad_id_old?: Maybe<Scalars['Float']['output']>;
  canOrderBeChanged?: Maybe<Scalars['Boolean']['output']>;
  cartItem: CartModel;
  cashback_id?: Maybe<Scalars['String']['output']>;
  city_id?: Maybe<Scalars['Float']['output']>;
  city_title?: Maybe<Scalars['String']['output']>;
  cln_id_old?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  coords?: Maybe<Scalars['String']['output']>;
  courierItem?: Maybe<CourierModel>;
  courier_id?: Maybe<Scalars['Float']['output']>;
  cur_id?: Maybe<Scalars['Float']['output']>;
  dadata?: Maybe<DadataModel>;
  dadataItem?: Maybe<DadataModel>;
  dadata_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  deliveryDate?: Maybe<Scalars['Timestamp']['output']>;
  deliveryIntervalTitle?: Maybe<Scalars['String']['output']>;
  deliveryStoreItem?: Maybe<StoresModel>;
  delivery_cost?: Maybe<Scalars['Float']['output']>;
  delivery_date?: Maybe<Scalars['Timestamp']['output']>;
  delivery_id?: Maybe<Scalars['Float']['output']>;
  delivery_store_id?: Maybe<Scalars['Int']['output']>;
  delivery_title?: Maybe<Scalars['String']['output']>;
  digital?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inet_id_old?: Maybe<Scalars['Float']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  interval_id?: Maybe<Scalars['Float']['output']>;
  interval_title?: Maybe<Scalars['String']['output']>;
  managerItem?: Maybe<OrdersManagersModel>;
  manager_comment?: Maybe<Scalars['String']['output']>;
  manager_id?: Maybe<Scalars['Int']['output']>;
  mng_id?: Maybe<Scalars['Float']['output']>;
  need_receipt?: Maybe<Scalars['Float']['output']>;
  one_click?: Maybe<Scalars['String']['output']>;
  opr_id?: Maybe<Scalars['Float']['output']>;
  ordBeg?: Maybe<Scalars['String']['output']>;
  ordEnd?: Maybe<Scalars['String']['output']>;
  ord_attr?: Maybe<Scalars['String']['output']>;
  ord_beg?: Maybe<Scalars['String']['output']>;
  ord_bns?: Maybe<Scalars['Float']['output']>;
  ord_bnsmns_old?: Maybe<Scalars['Float']['output']>;
  ord_bnspls_old?: Maybe<Scalars['Float']['output']>;
  ord_calcweight?: Maybe<Scalars['Float']['output']>;
  ord_date_old?: Maybe<Scalars['Timestamp']['output']>;
  ord_descr?: Maybe<Scalars['String']['output']>;
  ord_dscnt_old?: Maybe<Scalars['Float']['output']>;
  ord_end?: Maybe<Scalars['String']['output']>;
  ord_mark?: Maybe<Scalars['String']['output']>;
  ord_new?: Maybe<Scalars['String']['output']>;
  ord_pay?: Maybe<Scalars['Float']['output']>;
  ord_ship_old?: Maybe<Scalars['Float']['output']>;
  ord_state_old?: Maybe<Scalars['String']['output']>;
  ord_sum?: Maybe<Scalars['Float']['output']>;
  ord_weight?: Maybe<Scalars['Float']['output']>;
  ord_when_old?: Maybe<Scalars['Timestamp']['output']>;
  order?: Maybe<OrdersModel>;
  /** стоимость пакетов */
  orderContainerPrice?: Maybe<Scalars['Float']['output']>;
  orderLoyaltyItems: Array<OrderLoyaltyProgramModel>;
  orderMultiPricesItems: Array<OrderMultiPricesModel>;
  orderTestDriveItem: OrdersTestDrivesModel;
  ordersItems: Array<OrdersItemsModel>;
  paid?: Maybe<Scalars['String']['output']>;
  paid_date?: Maybe<Scalars['Timestamp']['output']>;
  paid_total?: Maybe<Scalars['Float']['output']>;
  paid_txn?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<OrdersPaymentsModel>;
  paymentItem?: Maybe<OrdersPaymentsModel>;
  payment_id?: Maybe<Scalars['Int']['output']>;
  payment_title?: Maybe<Scalars['String']['output']>;
  peopleAddress?: Maybe<PeopleAddressesModel>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  promoCodes?: Maybe<Array<OrdersPromocodesModel>>;
  promoCodesList?: Maybe<Array<PromocodesModel>>;
  promocodeItem?: Maybe<PromocodesModel>;
  promocode_id?: Maybe<Scalars['Float']['output']>;
  regionCityItem?: Maybe<StoresCityModel>;
  region_city_id?: Maybe<Scalars['Float']['output']>;
  rgn_id?: Maybe<Scalars['Float']['output']>;
  sberbankOrders?: Maybe<Array<OrdersSberbankModel>>;
  sberbankTransactions?: Maybe<Array<OrdersTransactionModel>>;
  secretKey?: Maybe<Scalars['String']['output']>;
  /** Услуги */
  servicesItems?: Maybe<Array<OrdersServicesModel>>;
  sk_num?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sovkomOrders?: Maybe<Array<OrdersSovkomModel>>;
  statusItem?: Maybe<OrdersStatusesModel>;
  status_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tinkoffOrders?: Maybe<Array<OrdersTinkoff>>;
  totalWithDeliveryPrice?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Timestamp']['output']>;
  us_id?: Maybe<Scalars['Float']['output']>;
  us_saver?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  war_descr?: Maybe<Scalars['String']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type OrdersPaymentsModel = {
  __typename?: 'OrdersPaymentsModel';
  active?: Maybe<Scalars['String']['output']>;
  api_active?: Maybe<Scalars['String']['output']>;
  bonus_percent?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  is_blocking?: Maybe<Scalars['Int']['output']>;
  is_digital?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  max_price?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  min_price?: Maybe<Scalars['Float']['output']>;
  ord_descr?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  possibleExtraBonus?: Maybe<Scalars['Float']['output']>;
  ptp_del?: Maybe<Scalars['String']['output']>;
  ptp_descr?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_short?: Maybe<Scalars['String']['output']>;
  title_short_admin?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  ympt?: Maybe<Scalars['String']['output']>;
};

export type OrdersPromocodesModel = {
  __typename?: 'OrdersPromocodesModel';
  id: Scalars['Float']['output'];
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  promocodeItem?: Maybe<PromocodesModel>;
  promocode_id?: Maybe<Scalars['Int']['output']>;
};

export type OrdersSberbankModel = {
  __typename?: 'OrdersSberbankModel';
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
};

export type OrdersServicesModel = {
  __typename?: 'OrdersServicesModel';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Float']['output'];
  is_for_manager?: Maybe<Scalars['Float']['output']>;
  is_subscription?: Maybe<Scalars['Float']['output']>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type OrdersSovkomModel = {
  __typename?: 'OrdersSovkomModel';
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
};

export type OrdersStatusesModel = {
  __typename?: 'OrdersStatusesModel';
  active?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OrdersTestDrivesModel = {
  __typename?: 'OrdersTestDrivesModel';
  catalogItem: CatalogModel;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  orderItem: OrdersModel;
  order_id?: Maybe<Scalars['Int']['output']>;
  testDriveItem: TestDriveModel;
  test_drive_id?: Maybe<Scalars['Float']['output']>;
};

export type OrdersTinkoff = {
  __typename?: 'OrdersTinkoff';
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
};

export type OrdersTransactionModel = {
  __typename?: 'OrdersTransactionModel';
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Int']['output']>;
};

export type PeopleAddressInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  coords?: InputMaybe<Scalars['String']['input']>;
  dadata?: InputMaybe<Scalars['Float']['input']>;
  fio?: InputMaybe<Scalars['String']['input']>;
  flat?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PeopleAddressMutationResponseType = {
  __typename?: 'PeopleAddressMutationResponseType';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  people?: Maybe<PeopleModel>;
  peopleAddress?: Maybe<PeopleAddressesModel>;
  success: Scalars['Boolean']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type PeopleAddressesModel = {
  __typename?: 'PeopleAddressesModel';
  cad_addr_old?: Maybe<Scalars['String']['output']>;
  cad_del?: Maybe<Scalars['String']['output']>;
  cad_descr?: Maybe<Scalars['String']['output']>;
  cad_name?: Maybe<Scalars['String']['output']>;
  cad_person?: Maybe<Scalars['String']['output']>;
  cad_sms?: Maybe<Scalars['String']['output']>;
  cad_tel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Справочник городов, - регион адреса брать из region_city_id */
  city_id?: Maybe<Scalars['Int']['output']>;
  cln_id?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  confirmedByUser?: Maybe<Scalars['Boolean']['output']>;
  coords?: Maybe<Scalars['String']['output']>;
  dadata?: Maybe<DadataModel>;
  dadataItem?: Maybe<DadataModel>;
  dadata_id?: Maybe<Scalars['Float']['output']>;
  deleted?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  formattedPhone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAvaliableForChange?: Maybe<Scalars['Boolean']['output']>;
  isValidForExpress?: Maybe<Scalars['Boolean']['output']>;
  is_confirmed_by_user?: Maybe<Scalars['Int']['output']>;
  is_primary?: Maybe<Scalars['Int']['output']>;
  is_recognised_by_dadata?: Maybe<Scalars['Int']['output']>;
  new_title?: Maybe<Scalars['String']['output']>;
  old_id?: Maybe<Scalars['Int']['output']>;
  old_title?: Maybe<Scalars['String']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  regionCityItem?: Maybe<StoresCityModel>;
  region_city_id?: Maybe<Scalars['Int']['output']>;
  rgn_id?: Maybe<Scalars['Int']['output']>;
  storeItem?: Maybe<StoresModel>;
  /** магазин пункта самовывоза; у адресов доставки пустой */
  store_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  timeid?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type PeopleBillLogModel = {
  __typename?: 'PeopleBillLogModel';
  amount?: Maybe<Scalars['Float']['output']>;
  billItem?: Maybe<PeopleBillModel>;
  bill_id?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  dateTime?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Int']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  news_id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<OrdersModel>;
  orderItem?: Maybe<OrdersModel>;
  order_id?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PeopleBillModel = {
  __typename?: 'PeopleBillModel';
  bill?: Maybe<Scalars['Float']['output']>;
  billAmount?: Maybe<Scalars['Float']['output']>;
  billLogItem?: Maybe<Array<PeopleBillLogModel>>;
  id: Scalars['Int']['output'];
  log?: Maybe<Array<PeopleBillLogModel>>;
  new_bill?: Maybe<Scalars['Float']['output']>;
  old_bill?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
};

export type PeopleModel = {
  __typename?: 'PeopleModel';
  activated?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Array<PeopleAddressesModel>>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  bill?: Maybe<PeopleBillModel>;
  billItem?: Maybe<PeopleBillModel>;
  birthday?: Maybe<Scalars['Timestamp']['output']>;
  birthdayDate?: Maybe<Scalars['Timestamp']['output']>;
  can_invite?: Maybe<Scalars['Float']['output']>;
  cartCookieId?: Maybe<Scalars['String']['output']>;
  cln_del?: Maybe<Scalars['String']['output']>;
  cln_name?: Maybe<Scalars['String']['output']>;
  cln_spam?: Maybe<Scalars['String']['output']>;
  cnt_favorites?: Maybe<Scalars['Float']['output']>;
  cookieId?: Maybe<Scalars['String']['output']>;
  cookie_id?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fb_id?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_new_loyalty_program?: Maybe<Scalars['Boolean']['output']>;
  landline_phone?: Maybe<Scalars['String']['output']>;
  last_date?: Maybe<Scalars['Timestamp']['output']>;
  login_locked?: Maybe<Scalars['String']['output']>;
  login_locked_date?: Maybe<Scalars['Timestamp']['output']>;
  lvl_id?: Maybe<Scalars['Float']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  min_auth_time?: Maybe<Scalars['Float']['output']>;
  min_order_price?: Maybe<Scalars['Float']['output']>;
  mng_id?: Maybe<Scalars['Float']['output']>;
  newLoyaltyProgram?: Maybe<Scalars['Boolean']['output']>;
  ok_id?: Maybe<Scalars['String']['output']>;
  opr_id?: Maybe<Scalars['Float']['output']>;
  ordersItem?: Maybe<Array<OrdersModel>>;
  partner_id?: Maybe<Scalars['Int']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  peopleProfileItem?: Maybe<PeopleProfileModel>;
  phone?: Maybe<Scalars['String']['output']>;
  postponed_quantity?: Maybe<Scalars['Float']['output']>;
  profile_id?: Maybe<Scalars['Int']['output']>;
  sb_sub?: Maybe<Scalars['String']['output']>;
  send_recipes?: Maybe<Scalars['Float']['output']>;
  servicesShowItems?: Maybe<ServicesShowModel>;
  settingsItem?: Maybe<PeopleSettingsModel>;
  statsItem?: Maybe<PeopleStatsModel>;
  statusItem?: Maybe<PeopleStatusModel>;
  status_id?: Maybe<Scalars['Int']['output']>;
  subscriptionItems?: Maybe<Array<SubscribersModel>>;
  type?: Maybe<Scalars['String']['output']>;
  vk_id?: Maybe<Scalars['String']['output']>;
  wrongLogins?: Maybe<Scalars['Float']['output']>;
};

export type PeopleMutationResponseType = {
  __typename?: 'PeopleMutationResponseType';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  people?: Maybe<PeopleModel>;
  success: Scalars['Boolean']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type PeopleNotificationModel = {
  __typename?: 'PeopleNotificationModel';
  date?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_checked?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PeopleProfileModel = {
  __typename?: 'PeopleProfileModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Int']['output'];
  parent_id?: Maybe<Scalars['Float']['output']>;
  pct?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_2?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PeopleSettingsModel = {
  __typename?: 'PeopleSettingsModel';
  catalog_sorting?: Maybe<Scalars['String']['output']>;
  epp_catalog?: Maybe<Scalars['Float']['output']>;
  is_order_notify_messengers?: Maybe<Scalars['Float']['output']>;
  is_order_notify_sms?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  save_payment_card?: Maybe<Scalars['Boolean']['output']>;
};

/** тип действия с пользователем */
export enum PeopleSmsAction {
  Code = 'CODE',
  Sms = 'SMS'
}

export type PeopleStatsModel = {
  __typename?: 'PeopleStatsModel';
  first_order_date?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Int']['output'];
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  prev_order_date?: Maybe<Scalars['Timestamp']['output']>;
  prev_order_price?: Maybe<Scalars['Float']['output']>;
  total_orders?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
};

export type PeopleStatusModel = {
  __typename?: 'PeopleStatusModel';
  active?: Maybe<Scalars['String']['output']>;
  cst_del?: Maybe<Scalars['String']['output']>;
  cst_ship?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  descr?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  intermediate_discount?: Maybe<Scalars['Float']['output']>;
  intermediate_price?: Maybe<Scalars['Float']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** тип адресса пользователя */
export enum PeopleTypeAddress {
  /** все адреса: и доставки, и пункты самовывоза */
  All = 'ALL',
  /** только адреса доставки - те, у которых store_id пустой */
  Delivery = 'DELIVERY',
  /** только пункты самовывоза - те, у которых store_id заполнен */
  Pickup = 'PICKUP'
}

export type PeopleUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fio?: InputMaybe<Scalars['String']['input']>;
  newLoyaltyProgram?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Float']['input']>;
  saveCardData?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Создание цифрового заказа */
export type PersonDataInput = {
  email: Scalars['String']['input'];
  fio: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Подсказка по сумме заказа */
export type PossibleBonusUnion = {
  __typename?: 'PossibleBonusUnion';
  /** все доступные уровни лояльности */
  allValidLoyaltyLevels?: Maybe<Array<LoyaltyProgramModel>>;
  /** Разрешены ли подарки (если не разрешены, то не надо их отображать) */
  isGiftAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Ближайшая по сумме заказа программа лояльности */
  loyaltyProgram?: Maybe<LoyaltyProgramModel>;
  /** Максимальное значение */
  maxValue?: Maybe<Scalars['Int']['output']>;
  /** все следующие уровни лояльности */
  nextLoyaltyLevels?: Maybe<Array<LoyaltyProgramModel>>;
  /** Разница в цене, после которой станет доступно максимальное значение */
  priceDifference?: Maybe<Scalars['Float']['output']>;
  /** Текущее значение */
  value?: Maybe<Scalars['Int']['output']>;
};

export type PromocodesModel = {
  __typename?: 'PromocodesModel';
  active?: Maybe<Scalars['String']['output']>;
  apply_many_times?: Maybe<Scalars['Float']['output']>;
  auto?: Maybe<Scalars['String']['output']>;
  canBeCancelled?: Maybe<Scalars['Int']['output']>;
  can_be_cancelled?: Maybe<Scalars['Float']['output']>;
  cartPromoCodes?: Maybe<Array<CartPromocodesModel>>;
  catalogItem?: Maybe<CatalogModel>;
  catalogRubric?: Maybe<CatalogTypesModel>;
  catalogRubricFilter?: Maybe<CatalogTypeFiltersModel>;
  catalogRubricFilterId?: Maybe<Scalars['Int']['output']>;
  catalogRubricId?: Maybe<Scalars['Int']['output']>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gift?: Maybe<CatalogModel>;
  giftItem?: Maybe<CatalogModel>;
  gift_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isTypeWithGift?: Maybe<Scalars['Boolean']['output']>;
  is_first_mobile_order?: Maybe<Scalars['Int']['output']>;
  is_for_new_people?: Maybe<Scalars['Float']['output']>;
  is_mobile_only?: Maybe<Scalars['Float']['output']>;
  max_activations?: Maybe<Scalars['Float']['output']>;
  minOrderPrice?: Maybe<Scalars['Float']['output']>;
  minProductsQuantity?: Maybe<Scalars['Float']['output']>;
  notify_about_max_activations?: Maybe<Scalars['Int']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  people_id?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<CatalogModel>;
  promoCodeType?: Maybe<PromocodesTypesModel>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeItem?: Maybe<PromocodesTypesModel>;
  type_id?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PromocodesTypesModel = {
  __typename?: 'PromocodesTypesModel';
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PromotionsItemsModel = {
  __typename?: 'PromotionsItemsModel';
  amount?: Maybe<Scalars['Float']['output']>;
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  getAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  promotionItem?: Maybe<PromotionsModel>;
  sold?: Maybe<Scalars['Float']['output']>;
  timeid?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PromotionsModel = {
  __typename?: 'PromotionsModel';
  active?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Scalars['String']['output']>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  bannersItem?: Maybe<Array<BannersModel>>;
  countPromotionItems?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  date_end?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  identifyIdURI?: Maybe<Scalars['String']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  profile_id?: Maybe<Scalars['Float']['output']>;
  promotionItems: Array<PromotionsItemsModel>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  afterOrderPromocode?: Maybe<AfterOrderPromocodeUnion>;
  blabla: Scalars['String']['output'];
  cart: CartModel;
  /** принудительно ограничено количество возвращаемых полей в товарах - в случае необходимости расширять через бэк */
  catalogAnalogs: Array<CatalogAnalogUnion>;
  checkAmountDay: CatalogAmountsModel;
  checkCartChanges: CheckCartUnion;
  checkMaxAvailableQuantityInOneOrder: Array<CheckMaxAvailableQuantityInOneOrderUnion>;
  /** clear auth cookie */
  clearCookie?: Maybe<Scalars['Boolean']['output']>;
  configValue?: Maybe<ConfigType>;
  countCacheKeys: Scalars['Float']['output'];
  delCache: Scalars['String']['output'];
  delCacheMultiple: Scalars['String']['output'];
  deliveryAddresses?: Maybe<Array<StoresModel>>;
  /**
   * принудительно ограничено количество возвращаемых полей в товарах - в случае необходимости расширять через бэк
   * @deprecated используйте getDeliveryIntervals
   */
  flexibleDeliveryIntervals: Array<DataFlexibleDeliveryIntervalsUnion>;
  flushCache: Scalars['String']['output'];
  geocode: Scalars['Float']['output'];
  getActiveStoreCitiesWithFields: Array<StoresCityModel>;
  getAmountStores: Array<StoresModel>;
  getAvailableTodayProducts: Array<CatalogModel>;
  getByClassifiers: Array<CatalogModel>;
  getCache: Scalars['String']['output'];
  getCacheKeys: Scalars['String']['output'];
  getCartFields: Array<CartModel>;
  getDeliveryIntervals: GetDeliveryIntervalsUnion;
  getForgottenCartsCartToken: Array<CartModel>;
  getOrderCancelReasons: Array<OrdersCancelReasonsModel>;
  getProductAvailableAmount?: Maybe<Scalars['Int']['output']>;
  getShops: Array<ShopModel>;
  getShops2: ShopUnion;
  getTTlCache: Scalars['String']['output'];
  hasCache: Scalars['String']['output'];
  hello?: Maybe<Scalars['String']['output']>;
  isAvailableForPurchase: Scalars['Boolean']['output'];
  isPersonRestrincted: Scalars['Boolean']['output'];
  isProductAmountAvailable: Scalars['Boolean']['output'];
  loggerFacadeLog: Scalars['String']['output'];
  marketingFail: Scalars['Boolean']['output'];
  maxAvailableAmount?: Maybe<Scalars['Int']['output']>;
  me?: Maybe<PeopleModel>;
  myNotificationsList: NotificationsListUnion;
  nearestDelivery: Array<CatalogDeliveryUnion>;
  notCheckedNotificationsAmount: Scalars['Int']['output'];
  paymentOptions: Array<OrdersPaymentsModel>;
  peopleAddresses: Array<PeopleAddressesModel>;
  pickupPointById?: Maybe<StoresModel>;
  pickupPoints: Array<StoresModel>;
  servicesAvailableForPurchase: Array<ServicesAvailableForPurchaseUnion>;
  setCache: Scalars['String']['output'];
  /** Получить ссылку на корзину, которой можно поделиться */
  shareCart: ShareCartUnion;
  testApi: Scalars['Float']['output'];
  testError?: Maybe<Scalars['String']['output']>;
  testPushNotification: Array<CartModel>;
  testRedConnection: Scalars['String']['output'];
  testRelatIds: Scalars['Float']['output'];
  todayLatestInterval: DeliveryLatestIntervalUnion;
};


export type QueryAfterOrderPromocodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Float']['input'];
  secretKey: Scalars['String']['input'];
};


export type QueryCartArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  recalculate?: Scalars['Boolean']['input'];
  strict?: Scalars['Boolean']['input'];
};


export type QueryCatalogAnalogsArgs = {
  cartToken: Scalars['String']['input'];
  catalogIds: Array<Scalars['Int']['input']>;
  coordinates: CoordinatesInput;
  deliveryDate: Scalars['Timestamp']['input'];
};


export type QueryCheckAmountDayArgs = {
  catalogId: Scalars['Int']['input'];
};


export type QueryCheckCartChangesArgs = {
  cartToken: Scalars['String']['input'];
};


export type QueryCheckMaxAvailableQuantityInOneOrderArgs = {
  cartToken: Scalars['String']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryConfigValueArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCountCacheKeysArgs = {
  key?: Scalars['String']['input'];
};


export type QueryDelCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDelCacheMultipleArgs = {
  key?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDeliveryAddressesArgs = {
  cartToken: Scalars['String']['input'];
  imageFilter?: ImgeFilterE;
};


export type QueryFlexibleDeliveryIntervalsArgs = {
  cartToken: Scalars['String']['input'];
  coordinates: CoordinatesInput;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<Array<DeliveryIntervalInput>>;
};


export type QueryGetAvailableTodayProductsArgs = {
  amountGreterThan?: InputMaybe<Scalars['Int']['input']>;
  productIds: Array<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetByClassifiersArgs = {
  classifiers: Array<Scalars['String']['input']>;
};


export type QueryGetCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCacheKeysArgs = {
  key?: Scalars['String']['input'];
};


export type QueryGetCartFieldsArgs = {
  cartId: Scalars['Int']['input'];
};


export type QueryGetDeliveryIntervalsArgs = {
  cartToken: Scalars['String']['input'];
  coordinates: CoordinatesInput;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<Array<DeliveryIntervalInput>>;
};


export type QueryGetProductAvailableAmountArgs = {
  catalogId: Scalars['Int']['input'];
};


export type QueryGetShopsArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetShops2Args = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTTlCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHasCacheArgs = {
  anyKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsAvailableForPurchaseArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryIsProductAmountAvailableArgs = {
  catalogId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};


export type QueryLoggerFacadeLogArgs = {
  level?: Scalars['String']['input'];
  message?: Scalars['String']['input'];
  model?: Scalars['String']['input'];
  title?: Scalars['String']['input'];
};


export type QueryMaxAvailableAmountArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  forWholeWeek?: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
  storeId: Scalars['Int']['input'];
};


export type QueryMeArgs = {
  type?: PeopleTypeAddress;
};


export type QueryMyNotificationsListArgs = {
  parameters: NotificationInput;
};


export type QueryNearestDeliveryArgs = {
  cartToken: Scalars['String']['input'];
};


export type QueryPaymentOptionsArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
  digital?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  store_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPeopleAddressesArgs = {
  type?: PeopleTypeAddress;
};


export type QueryPickupPointByIdArgs = {
  cartToken: Scalars['String']['input'];
  imageFilter?: ImgeFilterE;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPickupPointsArgs = {
  cartToken: Scalars['String']['input'];
  imageFilter?: ImgeFilterE;
};


export type QueryServicesAvailableForPurchaseArgs = {
  cartToken: Scalars['String']['input'];
  serviceId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySetCacheArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShareCartArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestPushNotificationArgs = {
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTestRedConnectionArgs = {
  expire?: InputMaybe<Scalars['Float']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTodayLatestIntervalArgs = {
  cartToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecipesBludoModel = {
  __typename?: 'RecipesBludoModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesIngredientsItemsModel = {
  __typename?: 'RecipesIngredientsItemsModel';
  catalogItem?: Maybe<CatalogModel>;
  catalog_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  ingredientItems?: Maybe<RecipesIngredientsModel>;
  ingredient_id?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesIngredientsModel = {
  __typename?: 'RecipesIngredientsModel';
  catalogItems?: Maybe<Array<CatalogModel>>;
  id: Scalars['Int']['output'];
  ingredientsItems?: Maybe<Array<RecipesIngredientsItemsModel>>;
  recipeItems?: Maybe<RecipesModel>;
  recipes_id?: Maybe<Scalars['Int']['output']>;
  timeid?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesInstructionModel = {
  __typename?: 'RecipesInstructionModel';
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  is_final?: Maybe<Scalars['Float']['output']>;
  recipeItems?: Maybe<RecipesModel>;
  recipes_id?: Maybe<Scalars['Int']['output']>;
  timeid?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesModel = {
  __typename?: 'RecipesModel';
  /** оценки сложности рецепта - показывает голосовал ли текущий пользователь  и какую оценку поставил. Если да, то показывается эту оценку в скобочках под общей средней */
  _votedDifficult?: Maybe<Scalars['Float']['output']>;
  /** оценки рейтинга рецепта - показывает голосовал ли текущий пользователь и какую оценку поставил. Если да, то показывается эту оценку в скобочках под общей средней */
  _votedRating?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  author?: Maybe<Scalars['String']['output']>;
  bludoItem?: Maybe<RecipesBludoModel>;
  bludo_id?: Maybe<Scalars['Int']['output']>;
  bobrabotkaItem?: Maybe<RecipesObrabotkaModel>;
  comments_number?: Maybe<Scalars['Float']['output']>;
  cooking_time?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  favoritesItems?: Maybe<Array<FavoritesModel>>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  identifyIdURI?: Maybe<Scalars['String']['output']>;
  /** В избранном рецепт или нет */
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modified_at?: Maybe<Scalars['Timestamp']['output']>;
  naznachenieItem?: Maybe<RecipesNaznachenieModel>;
  naznachenie_id?: Maybe<Scalars['Int']['output']>;
  obrabotka_id?: Maybe<Scalars['Int']['output']>;
  onmain?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  /** Показывает общий(средний) рейтинг, в отличии от поля _votedRating, которое показывает голосовал ли текущий пользователь  и какую оценку поставил. Если да, то показывается и то и то значение основное занчениеЖ общий рейтинг - подпись оценка пользователя например ХОРОШИЙ(ВАШ ГОЛОС — ПЛОХОЙ) https://yadi.sk/i/BtvHFYybRncbuw */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Количество голосов за рейтинг рецепта */
  rating_votes?: Maybe<Scalars['Float']['output']>;
  recipeIngredients?: Maybe<Array<RecipesIngredientsModel>>;
  recipeInstructions?: Maybe<Array<RecipesInstructionModel>>;
  /** Тоже самое что и slozhnost_id */
  recipes_difficult?: Maybe<Scalars['Int']['output']>;
  relProfile?: Maybe<Array<RecipesRelationsModel>>;
  seo_md?: Maybe<Scalars['String']['output']>;
  seo_mkw?: Maybe<Scalars['String']['output']>;
  seo_title?: Maybe<Scalars['String']['output']>;
  serving?: Maybe<Scalars['Float']['output']>;
  /** Сущность, содержащая общую(средную) оценку сложности рецепта, в отличии от поля _votedDifficult, которое показывает голосовал ли текущий пользователь и какую оценку поставил. Если да, то после оценки показывается оба значения: усредненное и оценка пользователя например ХОРОШИЙ(ВАШ ГОЛОС — ПЛОХОЙ) https://yadi.sk/i/z5zLgNcDV-ZoCw */
  slozhnostItem?: Maybe<RecipesSlozhnostModel>;
  slozhnost_id?: Maybe<Scalars['Int']['output']>;
  /** Количество голосов за сложность рецепта */
  slozhnost_votes?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  tip?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type_id?: Maybe<Scalars['Int']['output']>;
  typesItem?: Maybe<RecipesTypesModel>;
  video_code?: Maybe<Scalars['String']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
  video_title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesNaznachenieModel = {
  __typename?: 'RecipesNaznachenieModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['String']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['String']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type RecipesObrabotkaModel = {
  __typename?: 'RecipesObrabotkaModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesRelationsModel = {
  __typename?: 'RecipesRelationsModel';
  article_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Float']['output']>;
  people_profile_id?: Maybe<Scalars['Float']['output']>;
  profileItem: PeopleProfileModel;
  recipe_id?: Maybe<Scalars['Float']['output']>;
  video_article_id?: Maybe<Scalars['Float']['output']>;
};

export type RecipesSlozhnostModel = {
  __typename?: 'RecipesSlozhnostModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecipesTypesModel = {
  __typename?: 'RecipesTypesModel';
  active?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  recipesItems?: Maybe<Array<RecipesModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type RecommendedTimeItemUnion = {
  __typename?: 'RecommendedTimeItemUnion';
  price?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

/** Обновление данных в корзине */
export type SaveOrderInput = {
  /** Партнёрский кешбек */
  cashbackId?: InputMaybe<Scalars['String']['input']>;
  /** Продолжить оформление несмотря на то, что заказ мог измениться */
  continueAnyway?: InputMaybe<Scalars['Boolean']['input']>;
  /** Источник заказа: site, oneClick, iphone, android */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Координаты с Яндекс.Карт */
  ymCoordinates?: InputMaybe<CoordinatesInput>;
};

export type ScheduleItem = {
  __typename?: 'ScheduleItem';
  days: Scalars['String']['output'];
  hours: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type ServicesAvailableForPurchaseUnion = {
  __typename?: 'ServicesAvailableForPurchaseUnion';
  /** Состояние кнопки */
  button?: Maybe<Scalars['String']['output']>;
  /** Связанная услуга в корзине */
  cartService?: Maybe<CartServicesModel>;
  /** Период действия услуги */
  period?: Maybe<Scalars['String']['output']>;
  /** Цена услуги в зависимости от типа услуги и ряда дополнительных условий */
  price?: Maybe<Scalars['Int']['output']>;
  /** Связанная услуга */
  service?: Maybe<ServicesModel>;
};

export type ServicesModel = {
  __typename?: 'ServicesModel';
  catalogRubrics?: Maybe<Array<CatalogTypesModel>>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['Boolean']['output']>;
  hasDescription?: Maybe<Scalars['Boolean']['output']>;
  hasRelatedProducts?: Maybe<Scalars['Boolean']['output']>;
  has_related_products?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isTypeSubscription?: Maybe<Scalars['Boolean']['output']>;
  is_active?: Maybe<Scalars['Float']['output']>;
  is_group?: Maybe<Scalars['Float']['output']>;
  is_hidden?: Maybe<Scalars['Float']['output']>;
  is_multiple?: Maybe<Scalars['Float']['output']>;
  is_service_and_subscription_same_time?: Maybe<Scalars['Float']['output']>;
  maxQuantityInOrder?: Maybe<Scalars['Int']['output']>;
  max_quantity_in_order?: Maybe<Scalars['Float']['output']>;
  min_order_price_gold?: Maybe<Scalars['Float']['output']>;
  min_order_price_nominal?: Maybe<Scalars['Float']['output']>;
  min_order_price_silver?: Maybe<Scalars['Float']['output']>;
  modified_at?: Maybe<Scalars['Timestamp']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceWithSubscription?: Maybe<Scalars['Int']['output']>;
  price_with_subscription?: Maybe<Scalars['Float']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortDescriptionWithSubscription?: Maybe<Scalars['String']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  short_description_with_subscription?: Maybe<Scalars['String']['output']>;
  sorting_weight?: Maybe<Scalars['Float']['output']>;
  subscriptionPeriod?: Maybe<Scalars['Int']['output']>;
  subscriptionPrice?: Maybe<Scalars['Int']['output']>;
  subscription_period?: Maybe<Scalars['Float']['output']>;
  subscription_price?: Maybe<Scalars['Float']['output']>;
  svg_code?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type_id?: Maybe<Scalars['Float']['output']>;
};

export type ServicesShowModel = {
  __typename?: 'ServicesShowModel';
  automatically_add_to_cart?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Int']['output'];
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  serviceItem?: Maybe<ServicesModel>;
  service_id?: Maybe<Scalars['Int']['output']>;
};

export type ShareCartUnion = {
  __typename?: 'ShareCartUnion';
  /** Подписка на товар */
  cartShare?: Maybe<CartShareUnion>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Код ошибки */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** Сообщение */
  info?: Maybe<Scalars['String']['output']>;
  /** Результат выполнения запроса */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']['output']>;
};

export type ShopModel = {
  __typename?: 'ShopModel';
  address?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<StoreAttachmentsModel>>;
  geo?: Maybe<Array<Scalars['Float']['output']>>;
  icon_list?: Maybe<Scalars['String']['output']>;
  icon_map?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  identify?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<AttachmentsModel>>;
  images_landing?: Maybe<Array<AttachmentsModel>>;
  metroStations?: Maybe<Array<MetroStationsModel>>;
  nearestDelivery?: Maybe<CatalogDeliveryUnion>;
  opens_soon?: Maybe<Scalars['Boolean']['output']>;
  oyster_bar?: Maybe<Scalars['Boolean']['output']>;
  paymentTypes?: Maybe<Array<OrdersPaymentsModel>>;
  phone?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  review_widget?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Array<ScheduleItem>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ShopType>;
  ya_maps_url?: Maybe<Scalars['String']['output']>;
  yandex_reserve?: Maybe<Scalars['String']['output']>;
};

export enum ShopType {
  Cafe = 'cafe',
  OysterBar = 'oyster_bar',
  Shop = 'shop'
}

export type ShopUnion = {
  __typename?: 'ShopUnion';
  imagesLandingOysterMain?: Maybe<Array<StoresModel>>;
  shops?: Maybe<Array<ShopModel>>;
};

export type StoreAttachmentsModel = {
  __typename?: 'StoreAttachmentsModel';
  attachmentsItem?: Maybe<AttachmentsModel>;
  description?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<StoresAttachmentsType>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type StoreScheduleModel = {
  __typename?: 'StoreScheduleModel';
  day?: Maybe<Scalars['Int']['output']>;
  end_time?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  max_time?: Maybe<Scalars['Float']['output']>;
  start_time?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

export type StoreServicesModel = {
  __typename?: 'StoreServicesModel';
  id?: Maybe<Scalars['Int']['output']>;
  service_id?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
};

/** размер изображения для разных целей на сайте */
export enum StoresAttachmentsType {
  Landing = 'landing',
  Modal = 'modal'
}

/** Поля ключ-значения таблицы регионов */
export type StoresCityFieldsUnion = {
  __typename?: 'StoresCityFieldsUnion';
  geo_center?: Maybe<Scalars['String']['output']>;
  geo_suggestions?: Maybe<Scalars['String']['output']>;
};

export type StoresCityModel = {
  __typename?: 'StoresCityModel';
  active?: Maybe<Scalars['Int']['output']>;
  default_store_id?: Maybe<Scalars['Int']['output']>;
  fields?: Maybe<StoresCityFieldsUnion>;
  id?: Maybe<Scalars['Int']['output']>;
  is_default?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StoresFieldsModel = {
  __typename?: 'StoresFieldsModel';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StoresModel = {
  __typename?: 'StoresModel';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  amount_store?: Maybe<Scalars['Int']['output']>;
  attachmentsItems?: Maybe<Array<StoreAttachmentsModel>>;
  city_id?: Maybe<Scalars['Int']['output']>;
  coord?: Maybe<Scalars['String']['output']>;
  deliveryIntervals?: Maybe<Array<DataFlexibleDeliveryIntervalsUnion>>;
  description?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<StoresFieldsModel>>;
  has_amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_delivery?: Maybe<Scalars['Int']['output']>;
  is_mobile?: Maybe<Scalars['Int']['output']>;
  is_pickup?: Maybe<Scalars['Int']['output']>;
  min_order_price?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nearestAvailableInterval?: Maybe<DataFlexibleDeliveryIntervalsUnion>;
  parking?: Maybe<Scalars['String']['output']>;
  paymentTypes?: Maybe<Array<OrdersPaymentsModel>>;
  point?: Maybe<Scalars['String']['output']>;
  scheduleItems?: Maybe<Array<StoreScheduleModel>>;
  serviceItems?: Maybe<Array<StoreServicesModel>>;
  shop?: Maybe<ShopModel>;
  type?: Maybe<Scalars['String']['output']>;
  zones?: Maybe<StoresZonesModel>;
};

export type StoresZonesModel = {
  __typename?: 'StoresZonesModel';
  active?: Maybe<Scalars['Int']['output']>;
  aggregate?: Maybe<Scalars['String']['output']>;
  close_type?: Maybe<Scalars['String']['output']>;
  free_price?: Maybe<Scalars['Int']['output']>;
  has_intervals?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  min_interval?: Maybe<Scalars['Int']['output']>;
  min_price?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  store_id?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  time_delivery?: Maybe<Scalars['Int']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type SubscribersModel = {
  __typename?: 'SubscribersModel';
  active?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Scalars['String']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  average_check?: Maybe<Scalars['Float']['output']>;
  bill?: Maybe<Scalars['Float']['output']>;
  birthday?: Maybe<Scalars['Timestamp']['output']>;
  caviar_black?: Maybe<Scalars['String']['output']>;
  caviar_red?: Maybe<Scalars['String']['output']>;
  chilled_fish?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coordinator?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  date_order_first?: Maybe<Scalars['Timestamp']['output']>;
  date_order_last?: Maybe<Scalars['Timestamp']['output']>;
  date_reg?: Maybe<Scalars['Timestamp']['output']>;
  dishes?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fio?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  healthy_eating?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_newbee?: Maybe<Scalars['String']['output']>;
  is_waiting?: Maybe<Scalars['Float']['output']>;
  italian?: Maybe<Scalars['String']['output']>;
  japanese?: Maybe<Scalars['String']['output']>;
  live_seafood?: Maybe<Scalars['String']['output']>;
  meat?: Maybe<Scalars['String']['output']>;
  mexican?: Maybe<Scalars['String']['output']>;
  mushrooms?: Maybe<Scalars['String']['output']>;
  novelty?: Maybe<Scalars['String']['output']>;
  orders_per_month?: Maybe<Scalars['Float']['output']>;
  peopleItem?: Maybe<PeopleModel>;
  people_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  promo?: Maybe<Scalars['String']['output']>;
  recipes?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_orders?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

export type TestDriveModel = {
  __typename?: 'TestDriveModel';
  active?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  bids?: Maybe<Scalars['Float']['output']>;
  catalogItems?: Maybe<Array<CatalogModel>>;
  completed?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  descr_cart?: Maybe<Scalars['String']['output']>;
  descriptionForCart?: Maybe<Scalars['String']['output']>;
  fileItem?: Maybe<AttachmentsModel>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  identify?: Maybe<Scalars['String']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  minOrderPrice?: Maybe<Scalars['Float']['output']>;
  min_sum?: Maybe<Scalars['Float']['output']>;
  ordersItems?: Maybe<Array<OrdersTestDrivesModel>>;
  peopleCount?: Maybe<Scalars['Int']['output']>;
  peopleStatus?: Maybe<PeopleStatusModel>;
  people_status_id?: Maybe<Scalars['Float']['output']>;
  produtImages?: Maybe<Array<Scalars['String']['output']>>;
  relatedProducts?: Maybe<Array<TestDriveRelationsModel>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleForCart?: Maybe<Scalars['String']['output']>;
  title_cart?: Maybe<Scalars['String']['output']>;
};

export type TestDriveRelationsModel = {
  __typename?: 'TestDriveRelationsModel';
  amount?: Maybe<Scalars['Float']['output']>;
  amountTested?: Maybe<Scalars['Int']['output']>;
  amount_tested?: Maybe<Scalars['Float']['output']>;
  catalogItem: CatalogModel;
  catalog_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  peopleItem: PeopleModel;
  people_id?: Maybe<Scalars['Int']['output']>;
  product: CatalogModel;
  testCatalogItem: CatalogModel;
  testDriveItem: TestDriveModel;
  testOrderItem: OrdersModel;
  test_catalog_id?: Maybe<Scalars['Int']['output']>;
  test_date?: Maybe<Scalars['Timestamp']['output']>;
  test_order_id?: Maybe<Scalars['Int']['output']>;
};

/** Подсказка по сумме заказа */
export type TotalAmountUnion = {
  __typename?: 'TotalAmountUnion';
  cssClass?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
};

/** Обновление данных в корзине */
export type UpdateCartInput = {
  /** Адрес подтверждён пользователем */
  addressConfirmedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Комментарий к заказу */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** ID адреса пользователя */
  coords?: InputMaybe<Scalars['String']['input']>;
  /** ФИО адресата */
  dadataId?: InputMaybe<Scalars['Int']['input']>;
  /** Дата (день) доставки */
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  /** id доставки */
  deliveryId?: InputMaybe<Scalars['Int']['input']>;
  /** Конец интервала, выбранного пользователем (ЧЧ) */
  deliveryIntervalEnd?: InputMaybe<Scalars['Int']['input']>;
  /** ID интервала доставки */
  deliveryIntervalId?: InputMaybe<Scalars['Int']['input']>;
  /** Начало интервала, выбранного пользователем (ЧЧ) */
  deliveryIntervalStart?: InputMaybe<Scalars['Int']['input']>;
  /** Email адресата */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ФИО адресата */
  fio?: InputMaybe<Scalars['String']['input']>;
  /** Значение поля «Квартира, подъезд, этаж и домофон» */
  flat?: InputMaybe<Scalars['String']['input']>;
  /** выставить настройку меньше пакетов */
  lessContainers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Передавать ли чек покупателю */
  needReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Вариант оплаты */
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  /** ID адреса пользователя */
  peopleAddressId?: InputMaybe<Scalars['Int']['input']>;
  /** Номер телефона адресата */
  phone?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersModel = {
  __typename?: 'UsersModel';
  active?: Maybe<Scalars['String']['output']>;
  attachmentsItem?: Maybe<AttachmentsModel>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  medkn_id?: Maybe<Scalars['Float']['output']>;
  midname?: Maybe<Scalars['String']['output']>;
  min_auth_time?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  secondname?: Maybe<Scalars['String']['output']>;
};

export type WebPushModel = {
  __typename?: 'WebPushModel';
  date?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_mobile_app?: Maybe<Scalars['Boolean']['output']>;
  people_id?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};
